<template>
    <h2 class="text-gray-500 font-bold text-xs uppercase p-3 border-b-2 border-gray-100">
        <slot></slot>
    </h2>
</template>